import script from "./form.vue?vue&type=script&setup=true&lang=js"
export * from "./form.vue?vue&type=script&setup=true&lang=js"

import "./form.vue?vue&type=style&index=0&id=0d46b638&lang=scss"

const __exports__ = script;

export default __exports__